var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0187 23.1811H21.5756L12.0042 9.49023H10.4473L20.0187 23.1811Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9835 31.7541C24.5127 31.7541 31.4269 24.8398 31.4269 16.3106C31.4269 7.78145 24.5127 0.867188 15.9835 0.867188C7.4543 0.867188 0.540039 7.78145 0.540039 16.3106C0.540039 24.8398 7.4543 31.7541 15.9835 31.7541ZM16.9285 13.761L21.9322 7.94474H23.9794L17.8377 15.084L24.4293 24.6768H19.1031L14.8766 18.5259L9.58507 24.6768H7.53775L13.9677 17.2032L7.60599 7.94474H12.9321L16.9285 13.761Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX1);
export default __webpack_public_path__ + "static/media/x1.c9a1f77b25d83dc7c8c46acc6d8ea40d.svg";
export { ForwardRef as ReactComponent };